import { render, staticRenderFns } from "./OrderCalculatorOther.vue?vue&type=template&id=cff3a39c&scoped=true&"
import script from "./OrderCalculatorOther.vue?vue&type=script&lang=js&"
export * from "./OrderCalculatorOther.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalculatorOther.vue?vue&type=style&index=0&id=cff3a39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff3a39c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCard,VCardText,VSheet,VWindow,VWindowItem})
